/**
 * 用户
 */

import request from '@/utils/request'
// 获取菜单栏
export function usermenu() {
    return request({
        url: `/user/edu/cloud/get/my/menu?pfId=${window.g.platformCode}`,
        method: 'post'
    })
}
//退出登录
export function logout() {
    return request({
        url: '/user/user/logout',
        method: 'get'
    })
}
// 个人中心上传头像
export function userimgTo(data) {
    return request({
        url: '/basic/upload/hero/file',
        method: 'post',
        headers: { 'Content-Type': 'multipart/form-data' },
        data: data
    })
}
// 批量上传文件
export function filesArray(data) {
    return request({
        url: '/basic/upload/files',
        method: 'post',
        headers: { 'Content-Type': 'multipart/form-data' },
        data: data
    })
}
// 编辑账号(云平台)
export function modifyUser(data) {
    return request({
        url: '/user/edu/cloud/mod/account',
        method: 'post',
        data: data
    })
}
//修改密码(教育云)
export function updatePassword(data) {
    return request({
        url: '/user/edu/cloud/mod/password',
        method: 'post',
        data: data
    })
}

//发送邮箱验证码
export function sendEmail(data) {
    return request({
        url: '/user/user/send/email',
        method: 'post',
        data: {
            emailAddress: data
        }
    })
}

// 绑定邮箱（云平台）
export function mailBox(data) {
    return request({
        url: '/user/edu/cloud/bind/email',
        method: 'post',
        data: data
    })
}

// 解绑邮箱
// export function delmailBox(emailAddress) {
//     return request({
//         url: '/user/edu/unbind/email/address',
//         method: 'post',
//         data: {
//             emailAddress: emailAddress
//         }
//     })
// }

// 修改邮箱()
export function modmailBox(data) {
    return request({
        url: '/user/edu/cloud/bind/email',
        method: 'post',
        data: data
    })
}



//校验密码(修改账号使用)(教育云)
export function checkPassword(password) {
    return request({
        url: '/user/edu/cloud/check/password',
        method: 'post',
        data: {
            password: password
        }
    })
}

//修改手机号(教育云)
export function modmobile(bean) {
    return request({
        url: '/user/edu/cloud/mod/mobile',
        method: 'post',
        data: bean
    })
}
//修改学校识别码(教育)
export function modschoolcode(schoolCode) {
    return request({
        url: '/user/edu/mod/school/code',
        method: 'post',
        data: {
            schoolCode: schoolCode
        }
    })
}

//判断手机号是否注册
export function phoneisUse(username) {
    return request({
        url: '/user/user/hero/phone/isUse',
        method: 'post',
        data: {
            username
        }
    })
}

//根据手机号是否是本公司的员工
export function validEdu(username, schoolCode) {
    return request({
        url: `/user/user/phone/validEdu?username=${username}&schoolCode=${schoolCode}`,
        method: 'post',
    })
}


//转移学校管理员(教育)

export function transferadmin(data) {
    return request({
        url: '/user/edu/transfer/admin',
        method: 'post',
        data: data
    })
}


//删除用户(注销)

export function deleteUser(userId) {
    return request({
        url: "/user/edu/del/user",
        method: 'post',
        data: {
            userId: userId
        }
    })
}


//获取商品类别(容量)
export function categoryList() {
    return request({
        url: "/user/baseProduct/select/categoryList",
        method: 'post',
    })
}


//根据容量id获取商品列表

export function productByCategoryId(categoryId) {
    return request({
        url: "/user/baseProduct/query/product/list",
        method: 'post',
        data: categoryId
    })
}

//获取当前用户购买的套餐信息

export function product(categoryId) {
    return request({
        url: "/user/baseProduct/select/user/product",
        method: 'post',
        // data: {
        //   categoryId
        // }
    })
}
// 验证手机号是否被注册
export function jianTel(categoryId) {
    return request({
        url: "/user/user/hero/phone/isUse",
        method: 'post',
        data: {
            username: categoryId
        }
    })
}
//获取个人信息-全角色(云平台-个人信息)
export function info(data) {
    return request({
        url: "/user/edu/cloud/get/personal/info",
        method: 'post',
        data: {
            userId: data
        }
    })
}
// 根据用户id获取账号信息(云平台-账号管理)
export function userIdInfo(userId) {
    return request({
        url: "/user/edu/cloud/get/account/by/userId",
        method: 'post',
        data: {
            userId: userId
        }
    })
}

//统计在线用户人数
export function sendUserHeartbeat(data){
  return request({
    url: `/basic/edu/cloud/data/board/send/user/heartbeat?userId=${data.userId}&&userType=${data.userType}`,
    method: 'get',
      })
}

// 课表
export function getListByClassOrTeacherIsRelease(data) {
    return request({
        url: "/basic/timetable/getListByClassOrTeacherIsRelease",
        method: 'post',
        params: data
    })
}
// 获取当前老师是否是首次进入批改任务 教学活动模块
export function isOperate(data) {
    return request({
        url: "/basic/log/first/isOperate",
        method: 'post',
        data: data
    })
}
// 获取当前用户是否有当前菜单权限
export function selectUserRoleMenu(menuId,userId) {
    return request({
        url: `/basic/baseMenuAuth/hero/selectUserRoleMenu?menuId=${menuId}&userId=${userId}`,
        method: 'get',
    })
}



// WEBPACK FOOTER //
// ./src/api/usermenu.js